import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import TenantDetailsHeader from "../../components/TenantDetails/TenantDetailsHeader";
import TenantHeaderCard from "../../components/TenantDetails/TenantHeaderCard";
import TenantGreeting from "../../components/TenantDetails/TenantGreeting";
import ApplicationsModal from "../../components/TenantDetails/ApplicationsModal";
import NewApplicationModal from "../../components/TenantDetails/NewApplicationModal";
import FreeTextModal from "../../components/Tenant/FreeTextModal";
import FullidAuthentication from "../../components/Tenant/FullidAuthentication";
import useTranslator from "../../hooks/useTranslator";
import DetailsSkor from "../../components/TenantDetails/DetailsSkor";
import DetailsDocs from "../../components/TenantDetails/DetailsDocs";
import DataInfoModal from "../../components/TenantDetails/DataInfoModal";
import DetailsEmploymentInfo from "../../components/TenantDetails/DetailsEmploymentInfo";
import DetailsPersonalInfo from "../../components/TenantDetails/DetailsPersonalInfo";
import DetailsIncomeInfo from "../../components/TenantDetails/DetailsIncomeInfo";
import SkorAi from "../../assets/img/skorAI_logo.gif";
import noticIcon from "../../assets/img/noticIcon.svg";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import {
  calculateEffortRate,
  calculateEffortRatePercentageTenant,
  getCustomIncomeDetails,
  getEmploymentDocsMissing,
  getIdentityDetails,
  haveValue,
  isDefaulter,
  removeLeadingZerosAndHyphen,
  resolveIncomeSelection,
  toast,
  toTitleCase,
} from "../../helper/common";
import {
  calculateGuarantorScoreBreakdown,
  calculateTenantCompletionBreakdown,
  getDocumentCountsFromMissingResult,
  getKycScoreState,
  getRequiredEmploymentDocumentCount,
} from "../../helper/profileCompletionScore";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../services/authWrapper";
import Loader from "../../components/Loader";
import LandLordContext from "../../context/landlord/LandLordContext";
import UpdatedIncomeSourceModal from "../../components/TenantDetails/UpdateIncomeSourceModal";
import DefaultCheckReportModal from "../../components/TenantDetails/DefaultCheckReportModal";
import GuarantorDetails from "../../components/TenantDetails/GuarantorDetails";
import PendingRequestsPopup from "../../components/Tenant/Guarantor/PendingRequestsPopup";
import axiosInstanceInstance from "../../services/authWrapper";
import { useCookies } from "react-cookie";
import TenantContext from "../../context/tenant/TenantContext";
import ApplicationContext from "../../context/application/ApplicationContext";
import Summary from "../../components/Summary";
import SendTenantEmailDrawer from "../../components/SendTenantEmailDrawer";
import TenantProfileInsuranceModal from "../../components/TenantDetails/TenantProfileInsuranceModal";
import LinkedTenantsProperties from "../../components/TenantDetails/LinkedTenantsProperties";
import ConsentStepModal from "../onboarding/ConsentStepModal";
import DataLoadedError from "../../components/ErrorModal/DataLoadedError";
import RequestAcceptingModal from "../../components/Tenant/Guarantor/RequestAcceptingModal";
import DuplicateDocModal from "../../components/Onboarding/DuplicateDocModal";
import ProfileUpdateRequestModal from "../../components/TenantDetails/ProfileUpdateRequestModal";
import {
  createProfileReminder,
  getProfileReminders,
  startRenewProfile,
} from "../../services/sharedService";
import DummyHeader from "../../layouts/DummyHeader";
import DummyTenantDetailsHeader from "../../components/DummyTenantDetailsHeader";
import DetailsSkorStatic from "../../components/Tenant/DetailsSkorStatic";
import InvitationShareModal, {
  isSharedWithLandlord,
  JoinGroupScreen,
} from "../../components/InvitationShareModal";
import NoteForLandlord from "../../components/TenantDetails/NoteForLandlord";
import TargetRent from "../../components/TenantDetails/TargetRent";
import WaysToStrengthenProfile from "../../components/TenantDetails/WaysToStrengthenProfile";
import "./skorList.css";

function SkorList(props) {
  const authContext = useContext(AuthContext);
  const { setErrorDataLoading, errorDataLoading } = authContext;
  const [isSentEmailDrawer, SetIsSentEmailDrawer] = useState(false);
  const {
    setUserMaxRent = () => {},
    showReportIcons = true,
    adminTenantId,
  } = props;
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const location = useLocation();
  const {
    getAllData,
    checkIeDetails,
    user: originalUser,
    loadUserTenant,
    getPendingGuaantees,
  } = useContext(AuthContext);
  const {
    changeIncomeSource,
    changeFinancialIncomeSource,
    addCustomIncomeSource,
    deleteCustomIncomeSource,
    getPropertiesData,
    deaWorkspace,
    isCustomClientWorkspace,
  } = useContext(LandLordContext);
  const isDeaRulesActivated =
    originalUser?.current_workspace?.dea_rules_activated === true &&
    deaWorkspace;
  const {
    shareProfile,
    saveEffortRateData,
    getLandlordsConsentInfo,
    loadSharedProfiles,
    loadUploadedTenantDocs,
    uploadedTenantDocs,
    uploadedTenantDocsLoading,
    updateTenantRent,
  } = useContext(TenantContext);
  const {
    loadApplicationsData,
    loadLandlordRequests,
    myApplications,
    pendingApplications,
    applicationsLoaded,
    consentApplication,
    openLandlordLink,
    acceptLandlordRequest,
  } = useContext(ApplicationContext);
  const queryParameters = new URLSearchParams(window.location.search);
  const sharedprofileid = haveValue(props?.sharedprofileid)
    ? props.sharedprofileid
    : queryParameters.get("sharedprofileid");
  const agencylink = haveValue(props?.agencylink)
    ? props.agencylink
    : queryParameters.get("agencylink");
  const guarantor_id = haveValue(props?.guarantor)
    ? props.guarantor
    : queryParameters.get("guarantor");
  const tenant_id = haveValue(props?.tenant_id)
    ? props.tenant_id
    : queryParameters.get("tenant_id");
  const isGuarantor = haveValue(guarantor_id);
  const usertype = localStorage.getItem("usertype");
  const llShowOnly =
    localStorage.getItem("usertype") == "landlord" ||
    localStorage.getItem("usertype") == "admin";
  const [fullinfo, setFullinfo] = useState({});
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [fullInfoForGurantor, setFullInfoForGurantor] = useState({});
  const [forensicAnalysis, setForensicAnalysis] = useState(null);
  const [userIncome, setUserIncome] = useState(null);
  const [gurantorsIncome, setGurantorsIncome] = useState([]);
  const [totalGuarantorIncome, setTotalGuarantorIncome] = useState(null);
  const [totalGurantorIncomeForTable, setTotalGuarantorIncomeForTable] =
    useState(null);
  const [combinedIncome, setCombinedIncome] = useState(0);
  const [combinedIncomeForTable, setCombinedIncomeForTable] = useState(0);
  const [effortObj, setEffortObj] = useState("");
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [updateIncomeSourceModal, setUpdateIncomeSourceModal] = useState(false);
  const [showDefaulterCheck, setShowDefaulterCheck] = useState(false);
  const [verifiedDocs, setVerifiedDocs] = useState(new Map());
  const [claveDocs, setClaveDocs] = useState(new Map());
  const [docsMap, setDocsMap] = useState({});
  const [totalIncomeModal, setTotalIncomeModal] = useState(false);
  const [forensicRawData, setForensicRawData] = useState(null);
  const [showChatBot, setShowChatBot] = useState(false);
  const [openGuarantorModel, setOpenGuarantorModel] = useState(false);
  const [uploadDocModel, setUploadDocModel] = useState(false);
  const [showApplicationsModal, setShowApplicationsModal] = useState(false);
  const [showNewApplicationModal, setShowNewApplicationModal] = useState(false);
  const [showFreeTextPopup, setShowFreeTextPopup] = useState(false);
  const [showKycPopup, setShowKycPopup] = useState(false);
  const [
    selectedFinancialIncomeSourceData,
    setselectedFinancialIncomeSourceData,
  ] = useState({});
  const [selectedSources, setSelectedSources] = useState([]);
  const [pendingGuaranteesRequests, setPendingGuaranteesRequests] = useState(
    []
  );
  const [pendingRequestsGuranteesLoading, setPendingRequestsGuranteesLoading] =
    useState(false);
  const [Bankshow, setBankshow] = useState(false);
  const [reconnectFlow, setReconnectFlow] = useState(false);
  const [globalTenantDocuments, setGlobalTenantDocuments] = useState([]);
  const [globalAllForensicDocuments, setGlobalAllForensicDocuments] = useState(
    {}
  );
  const [globalMandatoryDocsList, setGlobalMandatoryDocsList] = useState({});
  const [globalTenantDocsHistory, setGlobalTenantDocsHistory] = useState({});
  const [tenantDocsHistoryReady, setTenantDocsHistoryReady] = useState(false);
  const [financial_info_errors, setFinancial_info_errors] = useState(null);

  const docsApiLoading = uploadedTenantDocsLoading === true;
  const mandatoryReady = Boolean(
    globalMandatoryDocsList && Object.keys(globalMandatoryDocsList).length
  );
  // Also wait for DetailsDocs to finish getUploadedDocuments -> tenantDocsHistory populated
  const docsHistoryLoading = !tenantDocsHistoryReady;
  // Wait until getUploadedDocuments + DetailsDocs history are ready - fixes 50%->19%->25% flicker
  const employmentMissingDocs = useMemo(() => {
    if (docsApiLoading || !mandatoryReady) return [];
    const historyKeys = Object.keys(globalTenantDocsHistory || {});
    const payslipCount = historyKeys.filter((k) =>
      k.toLowerCase().includes("payslip")
    ).length;
    const payslipOrder = [
      "1st month payslip",
      "2nd month payslip",
      "3rd month payslip",
    ];
    const expandedMandatory = {};
    Object.entries(globalMandatoryDocsList).forEach(([key, val]) => {
      const lower = key.toLowerCase();
      if (lower === "payslip" || lower === "last 3 payslips") {
        payslipOrder.forEach((k) => (expandedMandatory[k] = k));
      } else {
        expandedMandatory[key] = val;
      }
    });
    return Object.entries(expandedMandatory)
      .filter(([key]) => {
        const isPayslip = key.toLowerCase().includes("payslip");
        if (isPayslip) {
          const idx = payslipOrder.indexOf(key);
          if (idx !== -1 && idx < payslipCount) return false;
        }
        return !(key in (globalTenantDocsHistory || {}) && !isPayslip);
      })
      .map(([key]) => key);
  }, [
    globalMandatoryDocsList,
    globalTenantDocsHistory,
    docsApiLoading,
    mandatoryReady,
  ]);

  const employmentMissingCount =
    docsApiLoading || !mandatoryReady ? 0 : employmentMissingDocs.length;
  const requiredDocsList = useMemo(() => {
    if (docsApiLoading || !mandatoryReady) return [];
    // expanded required list for display
    const payslipOrder = [
      "1st month payslip",
      "2nd month payslip",
      "3rd month payslip",
    ];
    const list = [];
    Object.keys(globalMandatoryDocsList).forEach((k) => {
      if (["payslip", "last 3 payslips"].includes(k.toLowerCase()))
        payslipOrder.forEach((p) => list.push(p));
      else list.push(k);
    });
    return list;
  }, [globalMandatoryDocsList, docsApiLoading, mandatoryReady]);

  const monthlyIncomeVal = userIncome?.amount || 0;
  const backendTenantRent = user?.tenantRent ?? user?.targetRent;
  const [tenantRent, setTenantRent] = useState(null);
  const [hasPersistedTenantRent, setHasPersistedTenantRent] = useState(false);
  const tenantRentRef = useRef(null);
  const debounceRef = useRef(null);
  const tenantRentDirtyRef = useRef(false);
  const tenantRentUserIdRef = useRef(null);

  useEffect(() => {
    if (!user?._id) return;

    if (tenantRentUserIdRef.current !== user._id) {
      tenantRentUserIdRef.current = user._id;
      tenantRentDirtyRef.current = false;
      setHasPersistedTenantRent(
        backendTenantRent !== null && backendTenantRent !== undefined
      );
    }

    if (tenantRentDirtyRef.current) return;

    const persistedRent = Number(backendTenantRent);
    if (
      haveValue(backendTenantRent) &&
      Number.isFinite(persistedRent) &&
      persistedRent >= 0
    ) {
      setTenantRent(persistedRent);
      setHasPersistedTenantRent(true);
      return;
    }

    setHasPersistedTenantRent(false);
    setTenantRent(0);
  }, [backendTenantRent, monthlyIncomeVal, user?._id]);

  useEffect(
    () => () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      tenantRentRef.current?.abort();
    },
    []
  );

  const handleTenantRentChange = (val) => {
    const parsedRent = Number(val);
    const normalizedRent = Number.isFinite(parsedRent)
      ? Math.max(0, parsedRent)
      : 0;
    tenantRentDirtyRef.current = true;
    setTenantRent(normalizedRent);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (tenantRentRef.current) tenantRentRef.current.abort();
    const ctrl = new AbortController();
    tenantRentRef.current = ctrl;
    debounceRef.current = setTimeout(async () => {
      try {
        await updateTenantRent(normalizedRent, { signal: ctrl.signal });
        setHasPersistedTenantRent(true);
      } catch (e) {
        if (
          e?.code === "ERR_CANCELED" ||
          e?.name === "AbortError" ||
          e?.name === "CanceledError" ||
          e?.message === "canceled"
        )
          return;
        toast.error(_t("failedToUpdateTenantRent", "Failed to update rent"));
      }
    }, 1200);
  };
  const rentalBarometerStatus = useMemo(() => {
    const comfortableMax = Math.round((monthlyIncomeVal * 35) / 100);
    return (tenantRent ?? comfortableMax) > comfortableMax
      ? "Elevated"
      : "Comfortable";
  }, [tenantRent, monthlyIncomeVal]);
  const employmentTotalDocs = useMemo(() => {
    if (docsApiLoading || !mandatoryReady) return 0;
    const keys = Object.keys(globalMandatoryDocsList || {});
    if (!keys.length) return 0;
    const hasPayslip = keys.some((k) =>
      ["payslip", "last 3 payslips"].includes(k.toLowerCase())
    );
    return hasPayslip ? keys.length - 1 + 3 : keys.length;
  }, [globalMandatoryDocsList, docsApiLoading, mandatoryReady]);
  const guarantors = useMemo(
    () =>
      Array.isArray(user?.gurantor_id)
        ? user.gurantor_id.filter((guarantor) => haveValue(guarantor?._id))
        : [],
    [user?.gurantor_id]
  );
  const isGuarantorRequired =
    rentalBarometerStatus.toLowerCase() === "elevated";
  const [bestGuarantorContribution, setBestGuarantorContribution] = useState(0);
  const [guarantorScoreBreakdowns, setGuarantorScoreBreakdowns] = useState([]);
  const [guarantorScoreLoading, setGuarantorScoreLoading] = useState(false);
  const lastCompletionLogRef = useRef("");

  useEffect(() => {
    if (!isGuarantorRequired || guarantors.length === 0) {
      setBestGuarantorContribution(0);
      setGuarantorScoreBreakdowns([]);
      setGuarantorScoreLoading(false);
      return undefined;
    }

    let ignore = false;
    setGuarantorScoreLoading(true);

    Promise.allSettled(
      guarantors.map(async (guarantor) => {
        const missingDocumentsResult =
          await getEmploymentDocsMissing(guarantor);
        const documentCounts = getDocumentCountsFromMissingResult(
          missingDocumentsResult,
          getRequiredEmploymentDocumentCount(guarantor)
        );

        return calculateGuarantorScoreBreakdown({
          guarantor,
          documentCounts,
        });
      })
    ).then((results) => {
      if (ignore) return;

      const breakdowns = results.map((result, index) => {
        const guarantor = guarantors[index];
        if (result.status === "fulfilled") {
          return { ...result.value, fetchStatus: "fulfilled" };
        }

        return {
          guarantorId: guarantor?._id ?? null,
          guarantorName:
            [guarantor?.fname, guarantor?.lname].filter(Boolean).join(" ") ||
            null,
          fetchStatus: "rejected",
          error: result.reason?.message ?? "Failed to load guarantor documents",
        };
      });
      const successfulBreakdowns = breakdowns.filter(
        (breakdown) => breakdown.fetchStatus === "fulfilled"
      );
      const bestBreakdown = successfulBreakdowns.reduce(
        (best, breakdown) =>
          !best || breakdown.contribution > best.contribution
            ? breakdown
            : best,
        null
      );

      setGuarantorScoreBreakdowns(breakdowns);
      setBestGuarantorContribution(bestBreakdown?.contribution ?? 0);
      setGuarantorScoreLoading(false);
    });

    return () => {
      ignore = true;
    };
  }, [guarantors, isGuarantorRequired]);

  const bankConnected = Boolean(user?.bank_status && !financial_info_errors);
  const completionLoading =
    docsApiLoading ||
    docsHistoryLoading ||
    !mandatoryReady ||
    guarantorScoreLoading ||
    employmentTotalDocs === 0;
  const profileCompletionBreakdown = useMemo(() => {
    if (completionLoading) return null;
    return calculateTenantCompletionBreakdown({
      user,
      documentCounts: {
        requiredCount: employmentTotalDocs,
        missingCount: employmentMissingCount,
        missingDocs: employmentMissingDocs,
      },
      bankConnected,
      hasTargetRent: hasPersistedTenantRent,
      isGuarantorRequired,
      guarantorContribution: bestGuarantorContribution,
    });
  }, [
    bankConnected,
    bestGuarantorContribution,
    completionLoading,
    employmentMissingDocs,
    employmentMissingCount,
    employmentTotalDocs,
    hasPersistedTenantRent,
    isGuarantorRequired,
    user,
  ]);
  const profileCompletionPercent = profileCompletionBreakdown?.percentage ?? 0;

  useEffect(() => {
    if (completionLoading || !user?._id || !profileCompletionBreakdown) return;

    const roundPoints = (value) =>
      Number.isFinite(value) ? Math.round(value * 100) / 100 : value;
    const successfulGuarantors = guarantorScoreBreakdowns.filter(
      (breakdown) => breakdown.fetchStatus === "fulfilled"
    );
    const selectedGuarantor = successfulGuarantors.reduce(
      (best, breakdown) =>
        !best || breakdown.contribution > best.contribution ? breakdown : best,
      null
    );
    const consoleBreakdown = {
      documents: {
        requiredDocuments: requiredDocsList,
        missingDocuments: employmentMissingDocs,
        requiredCount: employmentTotalDocs,
        missingCount: employmentMissingCount,
        uploadedCount: Math.max(
          0,
          employmentTotalDocs - employmentMissingCount
        ),
      },
      finalScore: {
        percentage: profileCompletionBreakdown.percentage,
        earnedPoints: roundPoints(profileCompletionBreakdown.earnedPoints),
        applicableMaximum: profileCompletionBreakdown.applicableMaximum,
        formula: profileCompletionBreakdown.formula,
        rentalBarometerStatus,
      },
      tenant: {
        rawPoints: roundPoints(profileCompletionBreakdown.tenant.earnedPoints),
        rawMaximum: profileCompletionBreakdown.tenant.maximumPoints,
        components: profileCompletionBreakdown.tenant.components,
      },
      guarantor: {
        required: isGuarantorRequired,
        availableCount: guarantors.length,
        selectedMostCompleteGuarantorId: selectedGuarantor?.guarantorId ?? null,
        selectedContribution: roundPoints(
          profileCompletionBreakdown.guarantor.earnedContribution
        ),
        maximumContribution:
          profileCompletionBreakdown.guarantor.maximumContribution,
        candidates: guarantorScoreBreakdowns.map((breakdown) => ({
          ...breakdown,
          rawPoints: roundPoints(breakdown.rawPoints),
          completenessPercentage: roundPoints(breakdown.completenessPercentage),
          contribution: roundPoints(breakdown.contribution),
        })),
      },
    };
    const logSignature = JSON.stringify(consoleBreakdown);
    if (lastCompletionLogRef.current === logSignature) return;
    lastCompletionLogRef.current = logSignature;

    console.groupCollapsed(
      `[Profile completion] ${profileCompletionBreakdown.percentage}% — ${profileCompletionBreakdown.formula} | required: [${requiredDocsList.join(", ")}] | missing: [${employmentMissingDocs.join(", ") || "none"}]`
    );
    console.info("Full scoring breakdown", consoleBreakdown);
    console.info("Required documents", requiredDocsList);
    console.info("Missing documents", employmentMissingDocs);
    console.table(
      Object.entries(profileCompletionBreakdown.tenant.components).map(
        ([component, details]) => ({
          component,
          earned: roundPoints(details.earned),
          maximum: details.maximum,
          status:
            details.state ??
            details.completed ??
            details.connected ??
            details.persisted ??
            "see details",
          requiredDocuments: details.required,
          uploadedRequiredDocuments: details.uploadedRequired,
          missingRequiredDocuments: details.missing,
        })
      )
    );
    if (guarantorScoreBreakdowns.length > 0) {
      console.table(
        guarantorScoreBreakdowns.map((breakdown) => ({
          guarantor: breakdown.guarantorName ?? breakdown.guarantorId,
          fetchStatus: breakdown.fetchStatus,
          rawPoints: roundPoints(breakdown.rawPoints),
          rawMaximum: breakdown.rawMaximum,
          completenessPercentage: roundPoints(breakdown.completenessPercentage),
          contribution: roundPoints(breakdown.contribution),
          requiredDocuments: breakdown.components?.requiredDocuments?.required,
          uploadedRequiredDocuments:
            breakdown.components?.requiredDocuments?.uploadedRequired,
          missingRequiredDocuments:
            breakdown.components?.requiredDocuments?.missing,
          selected: breakdown.guarantorId === selectedGuarantor?.guarantorId,
          error: breakdown.error,
        }))
      );
    }
    console.groupEnd();
  }, [
    guarantorScoreBreakdowns,
    guarantorScoreLoading,
    guarantors.length,
    isGuarantorRequired,
    profileCompletionBreakdown,
    rentalBarometerStatus,
    user?._id,
  ]);
  const tenantKycState = getKycScoreState(user);
  const tenantKycLabel =
    tenantKycState === "approved"
      ? _t("verified", "Verified")
      : tenantKycState === "pending"
        ? _t("pending", "Pending")
        : _t("failed", "Failed");
  const [showConsent, setShowConsent] = useState(false);
  const [consentLandlordData, setConsentLandlordData] = useState({});
  const [hasDuplicates, setHasDuplicates] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateDocsByProfile, setDuplicateDocsByProfile] = useState({});
  const hasShownDuplicateModal = useRef(false);

  // bank account connectivity handling starts
  const error1 = queryParameters.get("error");
  let account_verification_report_id = queryParameters.get(
    "account_verification_report_id"
  );
  let transaction_report_id = queryParameters.get("transaction_report_id");
  const [paymentScoreLoading, setPaymentScoreLoading] = useState(false);
  const [scoreValue, setScoreValue] = useState(null);
  const [effortRateType, setEffortRateType] = useState(null);
  const [propertiesData, setPropertiesData] = useState([]);
  const [showPropertiesPopup, setShowPropertiesPopup] = useState(false);
  const [propertyDataLoading, setPropertyDataLoading] = useState(false);
  const [insurableModal, setInsurableModal] = useState(false);
  const [showProfileUpdateModal, setShowProfileUpdateModal] = useState(false);
  const [profileUpdateRequestedAt, setProfileUpdateRequestedAt] =
    useState(null);
  const [lastProfileReminderSentAt, setLastProfileReminderSentAt] =
    useState(null);
  const [profileUpdateReminderLoading, setProfileUpdateReminderLoading] =
    useState(false);
  const [profileRenewalLoading, setProfileRenewalLoading] = useState(false);

  // Share profile logic starts
  const [showEffortRateCalcuator, setShowEffortRateCalcuator] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies([
    "sharedProfileLink",
    "requestProfileLink",
    "joinGroupOnLandingPopup",
  ]);
  const isShareFlowRunning = useRef(false);
  const joinGroupTriggered = useRef(false);
  const [showInvitationShareModal, setShowInvitationShareModal] =
    useState(false);
  const postConsentActionRef = useRef(null);

  const isDummy = !!props.isDummySignup;

  // Standalone join-group (pending flatmate invitations not covered by InvitationShareModal)
  const [standaloneJoinApps, setStandaloneJoinApps] = useState([]);
  const [standaloneJoinProcessing, setStandaloneJoinProcessing] =
    useState(false);

  //accept modal
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [acceptedGuaranteeName, setAcceptedGuaranteeName] = useState("");
  const isPendingDataLoaded = useRef({
    guarantees: false,
    applications: false,
  });

  const isGuarantorUser = useMemo(() => user?.gurantor_for?.length > 0, [user]);

  useEffect(() => {
    const user_type = localStorage.getItem("usertype");
    const userId = localStorage.getItem("saveduserid");
    const isUserLoaded = user && Object.keys(user).length > 0;

    if (
      !isShareFlowRunning.current &&
      haveValue(cookies.requestProfileLink) &&
      user_type === "tenant" &&
      haveValue(userId) &&
      isUserLoaded &&
      //   #NOTE: Guarantor user is not allowed to share profile
      !isGuarantorUser
    ) {
      // Defer InvitationShareModal when signup join-group popup has priority
      if (haveValue(cookies.joinGroupOnLandingPopup)) return;
      isShareFlowRunning.current = true;
      setShowInvitationShareModal(true);
    }

    isCustomClientWorkspace(user?.email);
  }, [user, isGuarantorUser]);

  // Standalone join-group: show the latest pending flatmate invitation right after signup
  useEffect(() => {
    if (!applicationsLoaded || showInvitationShareModal) return;
    const user_type = localStorage.getItem("usertype");
    // Guarantors and non-tenants never see this modal
    if (user_type !== "tenant" || isGuarantorUser) return;

    const hasSignupCookie = haveValue(cookies.joinGroupOnLandingPopup);

    // Only activate once per signup landing; subsequent runs allowed only after trigger
    if (!hasSignupCookie && !joinGroupTriggered.current) return;

    if (hasSignupCookie && !joinGroupTriggered.current) {
      joinGroupTriggered.current = true;
    }

    // pendingApplications is already scoped to apps where this user has a pending invite
    const latest = [...(pendingApplications ?? [])].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
    const latestApplication = latest[0];

    // No pending app — clear the signup cookie and fall through to InvitationShareModal
    if (!latestApplication) {
      removeCookie("joinGroupOnLandingPopup", { path: "/" });
      setStandaloneJoinApps([]);
      if (
        haveValue(cookies.requestProfileLink) &&
        !isShareFlowRunning.current
      ) {
        isShareFlowRunning.current = true;
        setShowInvitationShareModal(true);
      }
      return;
    }

    // App is already shared with this landlord — skip standalone, go to InvitationShareModal
    if (
      haveValue(cookies.requestProfileLink) &&
      isSharedWithLandlord(latestApplication, cookies.requestProfileLink)
    ) {
      removeCookie("joinGroupOnLandingPopup", { path: "/" });
      setStandaloneJoinApps([]);
      if (!isShareFlowRunning.current) {
        isShareFlowRunning.current = true;
        setShowInvitationShareModal(true);
      }
      return;
    }

    setStandaloneJoinApps([latestApplication]);
  }, [pendingApplications, applicationsLoaded, user?.email, isGuarantorUser]);

  const handleStandaloneAccept = async () => {
    const app = standaloneJoinApps[0];
    if (!app) return;
    // Block InvitationShareModal from triggering during async operations
    isShareFlowRunning.current = true;
    try {
      setStandaloneJoinProcessing(true);
      await consentApplication(app._id, "accepted");
      // If user came via landlord link, also respond to that request with this group
      if (haveValue(cookies.requestProfileLink)) {
        const propertyId = cookies.property_id ?? null;
        const linkRes = await openLandlordLink(
          cookies.requestProfileLink,
          propertyId
        );
        const reqId =
          linkRes?.data?._id ?? linkRes?.success_res?._id ?? linkRes?._id;
        if (reqId) await acceptLandlordRequest(reqId, app._id);
        // Clear landlord-link cookies — InvitationShareModal won't open to do it
        removeCookie("requestProfileLink", { path: "/", maxAge: 1800 });
        if (haveValue(cookies.property_id))
          removeCookie("property_id", { path: "/", maxAge: 1800 });
        if (haveValue(cookies.invitationToken))
          removeCookie("invitationToken", { path: "/", maxAge: 1800 });
      }
      removeCookie("joinGroupOnLandingPopup", { path: "/" });
      removeCookie("tenantSignupFlow", { path: "/" });
      joinGroupTriggered.current = false;
      setStandaloneJoinApps([]);
      const userId = originalUser?._id ?? localStorage.getItem("saveduserid");
      await Promise.all([
        loadApplicationsData(),
        loadSharedProfiles(userId, "full"),
      ]);
    } catch {
      isShareFlowRunning.current = false;
      // toast.error(_t("failedToAcceptRequest", "Failed to accept request"));
    } finally {
      setStandaloneJoinProcessing(false);
    }
  };

  const handleStandaloneDecline = async () => {
    const app = standaloneJoinApps[0];
    if (!app) return;
    try {
      setStandaloneJoinProcessing(true);
      await consentApplication(app._id, "rejected");
      removeCookie("joinGroupOnLandingPopup", { path: "/" });
      joinGroupTriggered.current = false;
      setStandaloneJoinApps([]);
      // On decline, hand off to InvitationShareModal if landlord link exists
      if (haveValue(cookies.requestProfileLink)) {
        isShareFlowRunning.current = true;
        setShowInvitationShareModal(true);
      }
      const userId = originalUser?._id ?? localStorage.getItem("saveduserid");
      await Promise.all([
        loadApplicationsData(),
        loadSharedProfiles(userId, "full"),
      ]);
    } catch {
      toast.error(_t("failedToRejectRequest", "Failed to decline request"));
    } finally {
      setStandaloneJoinProcessing(false);
    }
  };

  useEffect(() => {
    const public_key = localStorage.getItem("publicKey");
    const isSdkUser = localStorage.getItem("app_type") === "skor-sdk";
    // console.log(
    //   "hiding",
    //   haveValue(public_key),
    //   isSdkUser,
    //   "loading",
    //   loading,
    //   "=>",
    //   haveValue(public_key) && isSdkUser && !loading
    // );
    if (haveValue(public_key) && isSdkUser && !loading) {
      setGlobalLoading(true);
    }
  }, []);

  // Share profile logic ends

  useEffect(() => {
    if (error1) {
      toast.error(_t("bankDetailsCannotBeFetched"));
    }
    if (account_verification_report_id && transaction_report_id) {
      //Add check here
      let userid = localStorage.getItem("saveduserid");
      if (isGuarantor) {
        userid = guarantor_id;
      }
      if (!userid) {
      } else {
        setScoreValue(null);
        setPaymentScoreLoading(true);
        calculateScore(
          userid,
          account_verification_report_id,
          transaction_report_id
        );
      }
    }
  }, [account_verification_report_id]);

  const updateTenantData = async (data) => {
    let user_id = localStorage.getItem("saveduserid");
    if (isGuarantor) {
      user_id = guarantor_id;
    }
    try {
      if (!haveValue(data?.is_edit)) {
        data.is_edit = true;
      }
      await axiosInstance.patch(
        `${process.env.REACT_APP_SERVER_URL}/users/profile/${user_id}`,
        data,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
    } catch (error) {
      console.log("Error updating user");
    }
  };

  const calculateScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    account_verification_report_id = null;
    transaction_report_id = null;
    await updateTenantData({
      bank_status: true,
      paymentScores: null,
      financial_info_errors: null,
      role: "tenant",
      isGuarantor,
    });
    setFinancial_info_errors(null);
    await clearPaymentData(userid);
    loadFullInfo(false);
    calculatePaymentScore(userid, accountverificationid, transactionreportid);
  };

  let paymentScoreInterval = null;
  const [isPollingActive, setIsPollingActive] = useState(false);

  const calculatePaymentScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    if (isDummy) return; // skip during dummy signup
    if (isPollingActive) {
      return;
    }

    let url = `${process.env.REACT_APP_SERVER_URL}/tenants/calculatescore?tenantid=${userid}&accountverificationid=${accountverificationid}&transactionreportid=${transactionreportid}`;
    if (isGuarantor) {
      url += "&guarantor=true";
    }

    axiosInstanceInstance
      .get(url)
      .then((res) => {
        let serverResponse = res.data;
        if (serverResponse.status !== "success") {
          if (serverResponse.status == "pending") {
            getAnalysisDetails();
          } else {
            toast.error(_t("skorCanNotBeCalculated"));
          }
        }
        if (serverResponse.status === "success") {
          loadFullInfo(false);
        }
        const url = new URL(window.location);
        url.searchParams.delete("account_verification_report_id");
        url.searchParams.delete("transaction_report_id");
        window.history.replaceState(
          {},
          document.title,
          url.pathname + url.search
        );
      })
      .catch(() => {});
  };
  const clearPaymentData = async (tenantid) => {
    return new Promise((resolve) => {
      let url = `${process.env.REACT_APP_SERVER_URL}/tenants/algoan-info?tenantid=${tenantid}`;
      if (isGuarantor) {
        url += "&guarantor=true";
      }
      axiosInstance
        .delete(url)
        .then((res) => {
          return resolve(true);
        })
        .catch((err) => {
          let err_res = err;
          toast.error(err_res.message);
          return resolve(null);
        });
    });
  };
  // bank account connectivity handling ends

  useEffect(() => {
    if (isDummy) return; // skip URL-driven actions during dummy signup

    const params = new URLSearchParams(location.search);
    const shouldOpen = params.get("uploadDocModel") === "true";

    if (shouldOpen) {
      setUploadDocModel(true);

      params.delete("uploadDocModel");
      navigate(
        { pathname: location.pathname, search: params.toString() },
        { replace: true }
      );
    }
  }, [location, navigate]);

  useEffect(() => {
    if (isDummy) return; // skip full info loading during dummy signup
    loadFullInfo();
  }, [location.search, adminTenantId]);

  useEffect(() => {
    if (haveValue(user) && haveValue(user?._id)) {
      loadUploadedTenantDocs(user._id, llShowOnly, isGuarantor);
    }
  }, [user]);

  useEffect(() => {
    if (
      haveValue(user) &&
      haveValue(user?.tenant_extra_field_id?.forensic_analysis)
    ) {
      const kycDetails = getIdentityDetails(user, user?.onfido_user_kyc);
      const allReports =
        user?.tenant_extra_field_id?.forensic_analysis?.profileReports ?? [];
      setForensicRawData(allReports);

      let matchedReport;
      if (haveValue(kycDetails.value)) {
        matchedReport =
          allReports.find((report) =>
            report?.report?.keyFactors?.keyFactors?.some((kf) => {
              if (!kf?.dataInJSON || typeof kycDetails?.value !== "string")
                return false;

              let expectedKey;
              if (kycDetails.type?.toLowerCase() === "dni") {
                expectedKey = "dni";
              } else if (kycDetails.type?.toLowerCase() === "passport") {
                expectedKey = "passportNumber";
              } else {
                return false; // type not supported
              }

              const fieldValue = kf?.dataInJSON?.[expectedKey];
              return (
                typeof fieldValue === "string" &&
                fieldValue.toLowerCase() === kycDetails.value.toLowerCase()
              );
            })
          ) || allReports[0];
      } else {
        matchedReport = allReports[0];
      }

      const temp_data = matchedReport?.report;
      const temp_key = {};
      temp_data?.keyFactors?.keyFactors.map((val) => {
        temp_key[val.keyFactor] = val;
      });
      const doc_list = {};
      (temp_data?.documents_list ?? []).map((val) => {
        doc_list[val?.document_id] = val;
      });
      setForensicAnalysis(temp_key);
      setDocsMap(doc_list);
    }
    if (haveValue(user)) {
      // making page blank
      const public_key = localStorage.getItem("publicKey");
      const isSdkUser = localStorage.getItem("app_type") === "skor-sdk";
      // console.log(
      //   "make page visible",
      //   public_key,
      //   isSdkUser,
      //   user?.api_client_id,
      //   haveValue(
      //     user?.tenant_extra_field_id?.forensic_analysis?.profileReports
      //   ),

      //   public_key &&
      //     isSdkUser &&
      //     haveValue(user?.api_client_id) &&
      //     haveValue(
      //       user?.tenant_extra_field_id?.forensic_analysis?.profileReports
      //     )
      // );
      if (
        public_key &&
        isSdkUser &&
        // haveValue(user?.api_client_id) &&
        haveValue(
          user?.tenant_extra_field_id?.forensic_analysis?.profileReports
        )
      ) {
        setGlobalLoading(false);
        // makePageVisible();
      }
    }
  }, [user]);

  useEffect(() => {
    const documentAnalysis =
      user?.tenant_extra_id?.document_analysis ??
      user?.tenant_extra_field_id?.document_analysis;

    const profiles = documentAnalysis?.profileReports ?? [];

    if (!profiles.length) {
      setHasDuplicates(false);
      setShowDuplicateModal(false);
      setDuplicateDocsByProfile({});
      return;
    }

    let globalHasDuplicates = false;
    const duplicatesMap = {};

    profiles.forEach((profile) => {
      const profileId = profile?.data?.owner || "unknown";
      const duplicateDocs = [];
      const seenDocNames = new Set();

      (profile?.report?.documentBuckets || []).forEach((docBucket) => {
        docBucket?.documents?.forEach((doc) => {
          if (!doc?.isDuplicate) return;

          globalHasDuplicates = true;

          const localizedName =
            doc?.documentNameTranslated?.[
              localStorage.getItem("i18nextLng") == "es" ? "es" : "en"
            ] || doc?.documentName;

          if (!seenDocNames.has(localizedName)) {
            seenDocNames.add(localizedName);
            duplicateDocs.push({
              name: localizedName,
              documentId: doc?.documentId,
              duplicateOf: doc?.duplicateOfDocumentId,
              bucketName: docBucket?.bucketName,
            });
          }
        });
      });

      if (duplicateDocs.length > 0) {
        duplicatesMap[profileId] = duplicateDocs;
      }
    });

    setHasDuplicates(globalHasDuplicates);
    setDuplicateDocsByProfile(duplicatesMap);
  }, [user]);

  useEffect(() => {
    if (
      !hasShownDuplicateModal.current &&
      hasDuplicates &&
      (user?.tenant_extra_id?.duplicate_doc_modal ||
        user?.tenant_extra_field_id?.duplicate_doc_modal) &&
      haveValue(originalUser) &&
      originalUser?.role === "tenant"
    ) {
      setShowDuplicateModal(true);
      hasShownDuplicateModal.current = true;
    }
  }, [hasDuplicates, user]);

  useEffect(() => {
    if (Object?.entries?.(duplicateDocsByProfile)?.length == 0) {
      setHasDuplicates(false);
      setShowDuplicateModal(false);
    }
  }, [duplicateDocsByProfile]);

  useEffect(() => {
    // financial income source get logic below
    const user_financial_income_sources = isGuarantor
      ? fullInfoForGurantor?.selected_financial_income_sources
      : resolveIncomeSelection(
          fullinfo?.income_selection,
          tenant_id ?? fullinfo?.tenantid?._id
        )?.selected_financial_income_sources;
    setselectedFinancialIncomeSourceData(user_financial_income_sources);
    // financial income source get logic above
  }, [fullInfoForGurantor, fullinfo]);

  const loadPropertiesData = async () => {
    try {
      setPropertyDataLoading(true);
      const propertiesData = await getPropertiesData(user?._id);
      setPropertiesData(propertiesData?.propertyData ?? []);
    } catch (error) {
      console.log("Failed to load properties");
    } finally {
      setPropertyDataLoading(false);
    }
  };

  useEffect(() => {
    const user_income_sources = resolveIncomeSelection(
      isGuarantor
        ? fullInfoForGurantor?.income_selection
        : fullinfo?.income_selection,
      tenant_id ?? fullinfo?.tenantid?._id
    );
    const fallbackIncome = isGuarantor
      ? fullInfoForGurantor?.useFallbackIncome
      : fullinfo?.useFallbackIncome;
    //   #NOTE: in case of application, use fallback from db needs a reset, but it is a OR condition,
    // therefore , we are sending true in case of application
    const isApplication = fullinfo?.application_id?.participants?.length > 0;
    const useFallbackIncome =
      typeof fallbackIncome === "boolean"
        ? fallbackIncome || isApplication
        : true;

    const gurantor_income_sources =
      user_income_sources?.[tenant_id ?? fullinfo?.tenantid?._id]
        ?.guarantor_sources ?? user_income_sources?.guarantor_sources;

    let profile_effort_rate_percentage = isGuarantor
      ? fullInfoForGurantor?.effort_rate_data?.guarantor?.[user?._id]
          ?.effort_rate_percentage
      : fullinfo?.effort_rate_data?.tenant?.effort_rate_percentage;

    if (llShowOnly && !haveValue(profile_effort_rate_percentage)) {
      profile_effort_rate_percentage =
        originalUser?.current_workspace?.default_effort_rate ?? 35;
    }
    // const incomeSelection = resolveIncomeSelection(
    //   fullinfo?.income_selection,
    //   fullinfo?.tenantid?._id
    // );

    // user income
    const user_income = getCustomIncomeDetails(
      user,
      originalUser,
      _t,
      usertype === "tenant"
        ? "declaredIncome"
        : isGuarantor
          ? gurantor_income_sources?.[user?._id]
          : user_income_sources?.tenant_source,
      !llShowOnly,
      //   useFallbackIncome, // need Fallback
      true,
      deaWorkspace,
      fullinfo?.custom_income_sources
    );

    setUserIncome(user_income);

    let totalGurantorIncome = 0;
    let totalGurantorIncomeForTable = 0;
    let allGurantorIncomes = [];
    let allGurantors = user?.gurantor_id;

    if (Array.isArray(allGurantors)) {
      allGurantors.forEach((gurantor) => {
        if (haveValue(gurantor)) {
          const income = getCustomIncomeDetails(
            gurantor,
            originalUser,
            _t,
            gurantor_income_sources?.[gurantor?._id],
            !llShowOnly,
            // useFallbackIncome,
            true,
            deaWorkspace,
            fullinfo?.custom_income_sources
          );
          // This view blocks guarantor income if guarantor is not selected
          if (
            [isGuarantor ? "tenant" : "guarantor", "both"]?.includes(
              effortRateType
            ) ||
            showEffortRateCalcuator
          ) {
            totalGurantorIncome += income?.amount || 0;
          }
          totalGurantorIncomeForTable += income?.amount || 0;
          allGurantorIncomes.push(income);
        }
      });
    }

    setGurantorsIncome(allGurantorIncomes);
    setTotalGuarantorIncome(totalGurantorIncome);
    setTotalGuarantorIncomeForTable(totalGurantorIncomeForTable);

    const userAmount =
      [isGuarantor ? "guarantor" : "tenant", "both"]?.includes(
        effortRateType
      ) || showEffortRateCalcuator
        ? +user_income?.amount
        : 0;

    const combinedIncome = userAmount + +totalGurantorIncome;
    setCombinedIncome(combinedIncome);

    const combinedIncomeForTable =
      user_income?.amount + +totalGurantorIncomeForTable;
    setCombinedIncomeForTable(combinedIncomeForTable);

    setUserMaxRent((prev) => ({
      ...prev,
      [user?._id]: combinedIncome ?? 0,
    }));

    if (showEffortRateCalcuator) {
      let temp_obj = calculateEffortRate(
        combinedIncomeForTable,
        originalUser,
        fullinfo
      );
      setEffortObj(temp_obj);
    } else {
      let temp_obj = calculateEffortRatePercentageTenant(
        combinedIncome,
        user,
        profile_effort_rate_percentage,
        llShowOnly
      );
      setEffortObj(temp_obj);
    }
  }, [
    user,
    fullinfo,
    fullInfoForGurantor,
    effortRateType,
    // showEffortRateCalcuator,
  ]);

  useEffect(() => {
    const experianData =
      user?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.["s:Body"]
        ?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3;

    const isUserDefauler = isDefaulter(experianData);

    if (originalUser?.role === "landlord" && !isUserDefauler) {
      loadPropertiesData();
    }
  }, [user, fullinfo, fullInfoForGurantor, effortRateType]);

  const loadFullInfo = async (needLoading = true) => {
    if (needLoading) {
      setLoading(true);
    }

    // Admin mode: load tenant data based on adminTenantId prop
    if (usertype === "admin" && haveValue(adminTenantId)) {
      const temp_data = {
        user_id: adminTenantId,
      };
      getAllData(temp_data, "tenant")
        .then((res) => {
          const temp = { tenantid: res.tenant };
          setFullinfo(temp);
          setUser(temp?.tenantid);
          setForensicAnalysis(null);
          if (needLoading) {
            setLoading(false);
          }
        })
        .catch((err) => {
          setErrorDataLoading(true);
          console.log("Error in skorlite admin mode", err);
          if (needLoading) {
            setLoading(false);
          }
        });
      return;
    }

    if (haveValue(guarantor_id)) {
      const temp_data = {
        user_id: guarantor_id,
      };
      try {
        const res = await getAllData(temp_data, "tenant");
        const temp = { tenantid: res.tenant };
        setFullinfo(temp);
        setUser(temp?.tenantid);
        setForensicAnalysis(null);
        await loadSharedProfileData("guarantorSide", tenant_id);
      } catch (err) {
        setErrorDataLoading(true);
        console.log("Error in skorlite", err);
      } finally {
        if (needLoading) {
          setLoading(false);
        }
      }
    } else {
      await loadSharedProfileData(null, tenant_id);
    }
  };

  const loadSharedProfileData = async (calledFrom = null, tenantId = null) => {
    if (haveValue(sharedprofileid)) {
      let url = `${
        process.env.REACT_APP_SERVER_URL
      }/shared-profile/singleshared/${sharedprofileid}?landlordId=${localStorage.getItem("saveduserid")}`;
      if (tenantId) {
        url += `&tenantId=${tenantId}`;
      }
      await axiosInstance
        .get(url, {
          headers: {
            "Accept-Language": localStorage.getItem("i18nextLng"),
          },
        })
        .then((res) => {
          let server_res = res;

          if (server_res.data.singleSharedProfile?.tenantid?.ie_details_id) {
            server_res.data.singleSharedProfile.tenantid.ie_verified =
              checkIeDetails(server_res.data.singleSharedProfile?.tenantid);
          }
          if (calledFrom === "guarantorSide") {
            setFullInfoForGurantor(server_res.data.singleSharedProfile);
            setFullinfo(server_res.data.singleSharedProfile);
          } else {
            setFullinfo(server_res.data.singleSharedProfile);
            setUser(server_res.data.singleSharedProfile?.tenantid);
          }
          loadUserTenant(usertype);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          setErrorDataLoading(true);
          if (err?.response?.data?.key === "insufficientCredits") {
            toast.error(_t(err?.response?.data?.key));
            navigate(`/${workspaceId}/profile-request`);
          }
        });
    }
    if (haveValue(agencylink)) {
      let url = `${
        process.env.REACT_APP_SERVER_URL
      }/shared-profile/agency-shared/${agencylink}?landlordId=${localStorage.getItem("saveduserid")}`;
      if (tenantId) {
        url += `&tenantId=${tenantId}`;
      }
      await axiosInstance
        .get(url, {
          headers: {
            "Accept-Language": localStorage.getItem("i18nextLng"),
          },
        })
        .then((res) => {
          let server_res = res;

          if (server_res.data.singleSharedProfile?.tenantid?.ie_details_id) {
            server_res.data.singleSharedProfile.tenantid.ie_verified =
              checkIeDetails(server_res.data.singleSharedProfile?.tenantid);
          }
          if (calledFrom === "guarantorSide") {
            setFullInfoForGurantor(server_res.data.singleSharedProfile);
          } else {
            setFullinfo(server_res.data.singleSharedProfile);
            setUser(server_res.data.singleSharedProfile?.tenantid);
          }
          loadUserTenant(usertype);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          if (err?.response?.data?.key === "insufficientCredits") {
            toast.error(_t(err?.response?.data?.key));
            navigate(`/${workspaceId}/profile-request`);
          }
        });
    }
    if (usertype === "tenant") {
      await loadUserTenant(usertype);
      setLoading(false);
    }
  };

  useEffect(() => {
    // Admin mode: load tenant data based on adminTenantId prop
    if (usertype === "admin" && haveValue(adminTenantId)) {
      const temp_data = {
        user_id: adminTenantId,
      };
      if (!haveValue(originalUser)) {
        loadUserTenant(usertype);
      }
      getAllData(temp_data, "tenant")
        .then((res) => {
          setUser(res.tenant);
          setForensicAnalysis(null);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
      return;
    }

    // Regular tenant mode
    if (usertype === "tenant") {
      if (!isPendingDataLoaded.current.guarantees) {
        loadPendingGuarantees();
        isPendingDataLoaded.current.guarantees = true;
      }

      if (
        !isPendingDataLoaded.current.applications &&
        originalUser &&
        Object.keys(originalUser).length > 0
      ) {
        if (originalUser?.gurantor_for?.length === 0) {
          loadApplicationsData();
          if (originalUser?.email) {
            loadLandlordRequests();
          }
        }
        isPendingDataLoaded.current.applications = true;
      }
      if (
        haveValue(guarantor_id) &&
        ((Array.isArray(originalUser?.gurantor_for) &&
          originalUser?.gurantor_for.some(
            (item) => item?._id === guarantor_id
          )) ||
          (Array.isArray(originalUser?.gurantor_id) &&
            originalUser?.gurantor_id.some(
              (item) => item?._id === guarantor_id
            )) ||
          (Array.isArray(originalUser?.gurantor_added_id) &&
            originalUser.gurantor_added_id.some(
              (item) => item?.guarantor_id?._id === guarantor_id
            )))
      ) {
        const temp_data = {
          user_id: guarantor_id,
        };
        getAllData(temp_data, "tenant")
          .then((res) => {
            setUser(res.tenant);
            setForensicAnalysis(null);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        setFullinfo({ tenant_id: originalUser });
        setUser(originalUser);
      }
    }
  }, [originalUser, adminTenantId]);

  const handleSaveEffortRateData = async (data) => {
    const payload = {
      type: data.type,
      data: {
        effort_rate_percentage: data?.effort_rate_percentage,
        effort_rate_type: data?.effort_rate_type,
      },
      tenant_id: data?.tenant_id,
    };

    if (llShowOnly) {
      const profileId =
        fullinfo?.tenant_id?.profileId ?? agencylink ?? sharedprofileid;

      const profileOf =
        haveValue(agencylink) || fullinfo?.tenant_id?.profileOf === "agency"
          ? "agency"
          : "sharedProfile";

      payload.target_type = isGuarantor ? "guarantor" : "tenant";
      payload.guarantor_id = isGuarantor ? guarantor_id : null;
      payload.source = profileId;
      payload.profileOf = profileOf;
    }

    await saveEffortRateData(payload);
  };

  const handleInfoModal = (data) => {
    setInfoModal(data);
    setOpenInfoModal(true);
  };

  const handleIncomeChange = async (
    source,
    isGuarantor,
    guarantorId,
    customIncomes = []
  ) => {
    const profileOf =
      haveValue(agencylink) || fullinfo?.tenant_id?.profileOf === "agency"
        ? "agency"
        : "sharedProfile";

    let updatedSource = source;
    const tempToRealIdMap = {};

    if (customIncomes.length > 0) {
      const tenantId = fullinfo?.tenantid?._id;
      const targetType = isGuarantor ? "guarantor" : "tenant";
      const guarantorIdValue = isGuarantor ? guarantorId : null;

      for (const inc of customIncomes) {
        const res = await addCustomIncomeSource(sharedprofileid, {
          tenantid: tenantId,
          target_type: targetType,
          guarantor_id: guarantorIdValue,
          custom_source: {
            name: inc.title,
            amount: Number(inc.amount) || 0,
            description: inc.title,
          },
        });

        if (res?.status === "success") {
          tempToRealIdMap[inc.sourceKey] = `custom_income:${inc.title}`;
        }
      }

      if (Array.isArray(updatedSource)) {
        updatedSource = updatedSource.map((key) => tempToRealIdMap[key] || key);
      }
    }

    const payload = {
      target_type: isGuarantor ? "guarantor" : "tenant",
      guarantor_id: isGuarantor ? guarantorId : null,
      source: updatedSource,
      profileOf,
      tenantid: tenant_id ?? fullinfo?.tenantid?._id,
    };

    return changeIncomeSource(sharedprofileid, payload);
  };

  const handleDeleteCustomIncome = async (customSourceId, userType, userId) => {
    const id =
      (fullinfo?._id?.$oid || fullinfo?._id) ??
      fullinfo?.tenant_id?.profileId ??
      agencylink ??
      sharedprofileid;
    const tenantId = fullinfo?.tenantid?._id;
    const targetIsGuarantor = userType === "guarantor" || isGuarantor;
    const specificGuarantorId =
      targetIsGuarantor && userId ? userId : guarantor_id;
    try {
      const payload = {
        tenantid: tenantId,
        target_type: targetIsGuarantor ? "guarantor" : "tenant",
        guarantor_id: targetIsGuarantor ? specificGuarantorId : undefined,
      };
      const res = await deleteCustomIncomeSource(id, customSourceId, payload);
      if (res?.status === "success") {
        toast.success(
          _t("customIncomeDeleted", "Custom income deleted successfully")
        );
        await loadFullInfo();
      } else {
        toast.error(
          _t("failedToDeleteCustomIncome", "Failed to delete custom income")
        );
      }
    } catch (err) {
      toast.error(
        _t("failedToDeleteCustomIncome", "Failed to delete custom income")
      );
    }
  };

  const handleFinancialIncomeChange = async (
    sources,
    isGuarantor,
    guarantorId
  ) => {
    // This function is used to change the income source from financial information (tink)
    const id = fullinfo?.tenant_id?.profileId ?? agencylink ?? sharedprofileid;
    const profileOf =
      haveValue(agencylink) || fullinfo?.tenant_id?.profileOf === "agency"
        ? "agency"
        : "sharedProfile";

    const payload = {
      target_type: isGuarantor ? "guarantor" : "tenant",
      guarantor_id: isGuarantor ? guarantorId : null,
      sources,
      profileOf,
      tenantid: fullinfo?.tenantid?._id,
    };

    changeFinancialIncomeSource(id, payload)
      .then((res) => {
        if (res?.status === "success") {
          loadFullInfo(false);
        }
      })
      .catch(() => {
        toast.error(_t("failedToChangeFinancialIncomeSource"));
      })
      .finally(() => {
        setUpdateIncomeSourceModal(false);
      });
  };

  const [updateSourceObj, setUpdateSourceObj] = useState({
    _id: "",
    all_sources: {},
    current_selected: "",
  });

  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "en-us");
  }, [localStorage.getItem("i18nextLng")]);

  useEffect(() => {
    if (!llShowOnly || !user?._id || !fullinfo?.tenantid?.is_outdated) return;

    let ignore = false;
    setProfileUpdateRequestedAt(null);
    setLastProfileReminderSentAt(null);
    getProfileReminders(user._id)
      .then((response) => {
        if (!ignore) {
          setProfileUpdateRequestedAt(response?.data?.[0]?.sent_at || null);
        }
      })
      .catch((error) => console.log(error));

    return () => {
      ignore = true;
    };
  }, [llShowOnly, user?._id, fullinfo?.tenantid?.is_outdated]);

  // useEffect(() => {
  //   const guarantorFor = localStorage.getItem("guarantorFor");
  //   if (haveValue(guarantorFor)) {
  //     loadPendingGuarantees({ requested_tenant_id: guarantorFor });
  //   }
  // }, [localStorage.getItem("guarantorFor")]);

  useEffect(() => {
    if (isDummy) return; // skip analysis polling during dummy signup

    if (
      user?.bank_status &&
      !haveValue(user?.paymentScores) &&
      haveValue(user?.algoanCustomerId) &&
      haveValue(user?.algoanAnalysisId) &&
      !haveValue(user?.financial_info_errors) &&
      !isPollingActive
    ) {
      getAnalysisDetails();
    }
  }, [user, isPollingActive]);

  // store interval id outside the function so we can reuse it

  const getAnalysisDetails = () => {
    if (isDummy) return; // skip during dummy signup
    if (usertype === "landlord") {
      return;
    }

    // Prevent multiple polling sessions
    if (isPollingActive) {
      return;
    }

    const userid = localStorage.getItem("saveduserid");

    // Clear any existing interval
    if (paymentScoreInterval) {
      clearInterval(paymentScoreInterval);
      paymentScoreInterval = null;
    }

    // Set polling flag
    setIsPollingActive(true);
    setPaymentScoreLoading(true);

    paymentScoreInterval = setInterval(async () => {
      try {
        const res = await axiosInstance.get(
          `${process.env.REACT_APP_SERVER_URL}/tenants/checkForPaymentScoreData?tenant_id=${userid}`,
          {
            headers: {
              "Accept-Language": localStorage.getItem("i18nextLng"),
            },
          }
        );

        if (res.data?.havePaymentScore) {
          // Clear interval and reset flags
          clearInterval(paymentScoreInterval);
          paymentScoreInterval = null;
          setIsPollingActive(false);
          setPaymentScoreLoading(false);
          loadFullInfo(false);
        }
        if (haveValue(res.data?.financial_info_errors)) {
          clearInterval(paymentScoreInterval);
          paymentScoreInterval = null;
          setIsPollingActive(false);
          setPaymentScoreLoading(false);
          setFinancial_info_errors(res.data?.financial_info_errors);
          loadFullInfo(false);
        }
      } catch (err) {
        console.error("Error checking payment score:", err);
        // Clear interval and reset flags on error
        clearInterval(paymentScoreInterval);
        paymentScoreInterval = null;
        setIsPollingActive(false);
        setPaymentScoreLoading(false);
      }
    }, 5000);
  };

  // cleanup when component unmounts
  useEffect(() => {
    return () => {
      if (paymentScoreInterval) {
        clearInterval(paymentScoreInterval);
        paymentScoreInterval = null;
      }
      setIsPollingActive(false);
    };
  }, []);

  const loadPendingGuarantees = async (data) => {
    if (isDummy) return; // skip during dummy signup
    setPendingRequestsGuranteesLoading(true);
    try {
      const response = await getPendingGuaantees(data);
      const firstGuarantee = haveValue(response?.success_res?.[0])
        ? [response?.success_res?.[0]]
        : [];
      setPendingGuaranteesRequests(firstGuarantee);
    } catch (e) {
      console.error(e);
      toast.error(
        _t(
          "failedToLoadPendingRequests",
          "Text used in guarantees pending requests popup"
        )
      );
    } finally {
      setPendingRequestsGuranteesLoading(false);
    }
  };

  const identityNumber = getIdentityDetails(user, user?.onfido_user_kyc);
  const passportNumber = haveValue(
    forensicAnalysis?.Passport?.dataInJSON?.passportNumber
  )
    ? forensicAnalysis?.Passport?.dataInJSON?.passportNumber
    : haveValue(user?.passport_id)
      ? user?.passport_id
      : null;

  const dniNumber = haveValue(forensicAnalysis?.DNI?.dataInJSON?.dni)
    ? forensicAnalysis?.DNI?.dataInJSON?.dni
    : haveValue(user?.dni_nie)
      ? user?.dni_nie
      : null;

  const isNumberMatching =
    identityNumber?.showTick &&
    (removeLeadingZerosAndHyphen(identityNumber?.value?.toLowerCase()) ===
      removeLeadingZerosAndHyphen(passportNumber?.toLowerCase()) ||
      removeLeadingZerosAndHyphen(identityNumber?.value?.toLowerCase()) ===
        removeLeadingZerosAndHyphen(dniNumber?.toLowerCase()));

  const handleNavigateReport = () => {
    const sharedId =
      queryParameters.get("agencylink") ||
      queryParameters.get("sharedprofileid");
    let queryParam = haveValue(queryParameters.get("agencylink"))
      ? `agencylink=${sharedId}`
      : `sharedprofileid=${sharedId}`;
    if (haveValue(guarantor_id)) {
      queryParam += `&guarantor_id=${guarantor_id}`;
    }
    window.open(
      `https://${process.env.REACT_APP_URL_NAME}/${
        haveValue(workspaceId) ? workspaceId + "/" : ""
      }generatedReport/${sharedId}?${queryParam}`,
      "_blank"
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (isDummy) {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [isDummy]);

  if (loading) return <Loader />;

  if (isDummy) {
    return (
      <>
        <DummyHeader />
        <div className="main-page-wrapper-tenant">
          <DummyTenantDetailsHeader />
          <div className="Profile_summary tenant_Profile_summary">
            <DetailsSkorStatic />
          </div>
          <div className="fetching-data-comp mt-3 fetching-data-comp-2">
            <div className="fetching-data-comp-info">
              <div className="fetching-data-comp-img">
                <img src="/images/fetching-data-icon.svg" alt="" />
              </div>
              <h1>{_t("fetchingYourData")}</h1>
              <p>
                {_t(
                  "aForensicReportIsBeingRunToFetchAllYourDataFromYourUploadedDocumentsItMightTake5-10Minutes"
                )}
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (errorDataLoading)
    return (
      <div style={{ marginTop: "9vw" }}>
        <DataLoadedError />
      </div>
    );

  const userType = localStorage.getItem("usertype");
  const tenantFirstName =
    user?.fname || [user?.fname, user?.lname].filter(Boolean).join(" ");
  const formatProfileDate = (value) => {
    const date = new Date(value);
    return Number.isNaN(date.getTime())
      ? ""
      : new Intl.DateTimeFormat(currentLang, {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }).format(date);
  };
  const requestedOn = formatProfileDate(profileUpdateRequestedAt);
  const handleSendProfileUpdateReminder = async () => {
    try {
      setProfileUpdateReminderLoading(true);
      const response = await createProfileReminder(user?._id);
      const sentAt = response?.data?.sent_at || new Date().toISOString();
      setProfileUpdateRequestedAt(sentAt);
      setLastProfileReminderSentAt(sentAt);
      toast.success(
        _t(
          profileUpdateRequestedAt
            ? "profileUpdateReminderSent"
            : "profileUpdateRequestSent",
          profileUpdateRequestedAt
            ? "Profile update reminder sent"
            : "Profile update request sent"
        )
      );
      return true;
    } catch (error) {
      toast.error(
        _t(
          "profileUpdateRequestFailed",
          "Failed to send profile update request"
        )
      );
      return false;
    } finally {
      setProfileUpdateReminderLoading(false);
    }
  };
  const handleStartRenewProfile = async () => {
    try {
      setProfileRenewalLoading(true);
      const response = await startRenewProfile();
      if (response?.success) {
        await loadUserTenant(usertype);
        // toast.success(
        //   _t("profileRenewedSuccessfully", "Profile updated successfully")
        // );
      }
    } catch (error) {
      toast.error(_t("failedToRenewProfile", "Failed to update profile"));
    } finally {
      setProfileRenewalLoading(false);
    }
  };

  const profileDetailsReady =
    (user?.forensic_status === "COMPLETED" ||
      (user?.role === "tenant" &&
        haveValue(
          user?.tenant_extra_field_id?.forensic_analysis?.profileReports
        ))) &&
    !fullinfo?.pendingDecision;

  const renderDocumentsSection = () => (
    <DetailsDocs
      user={user}
      setClaveDocs={setClaveDocs}
      setVerifiedDocs={setVerifiedDocs}
      forensicRawData={forensicRawData}
      forensicAnalysis={forensicAnalysis}
      uploadDocModel={uploadDocModel}
      setUploadDocModel={setUploadDocModel}
      isGuarantor={isGuarantor}
      currentLang={currentLang}
      setGlobalTenantDocuments={setGlobalTenantDocuments}
      setGlobalAllForensicDocuments={setGlobalAllForensicDocuments}
      setGlobalMandatoryDocsList={setGlobalMandatoryDocsList}
      setGlobalTenantDocsHistory={(val) => {
        setGlobalTenantDocsHistory(val);
        setTenantDocsHistoryReady(true);
      }}
      onDocsLoadingChange={(isLoading) => {
        if (isLoading) setTenantDocsHistoryReady(false);
      }}
      llShowOnly={llShowOnly}
      isDeaRulesActivated={isDeaRulesActivated}
    />
  );

  const renderInformationSection = (className) => (
    <div className={className}>
      <DetailsPersonalInfo
        user={user}
        forensicAnalysis={forensicAnalysis}
        handleInfoModal={handleInfoModal}
        currentLang={currentLang}
        llShowOnly={llShowOnly}
      />
      <DetailsEmploymentInfo
        user={user}
        forensicAnalysis={forensicAnalysis}
        handleInfoModal={handleInfoModal}
        currentLang={currentLang}
        llShowOnly={llShowOnly}
      />
      <DetailsIncomeInfo
        user={user}
        forensicAnalysis={forensicAnalysis}
        handleInfoModal={handleInfoModal}
        llShowOnly={llShowOnly}
      />
    </div>
  );

  const renderDetailsLoadingState = () => (
    <div className="fetching-data-comp">
      <div className="fetching-data-comp-info">
        <div className="fetching-data-comp-img">
          <img src="/images/fetching-data-icon.svg" alt="" />
        </div>
        {fullinfo?.pendingDecision ? (
          <h1>{_t("pendingDecisionFromTenant")}</h1>
        ) : (
          <>
            <h1>{_t("fetchingYourData")}</h1>
            <p>
              {_t(
                "aForensicReportIsBeingRunToFetchAllYourDataFromYourUploadedDocumentsItMightTake5-10Minutes"
              )}
            </p>
          </>
        )}
      </div>
    </div>
  );

  const renderScoreSection = ({ hideEffortRate = false } = {}) => (
    <div
      className={`skor-profile-layout__score Profile_summary ${
        llShowOnly &&
        !isNumberMatching &&
        identityNumber.name &&
        user?.forensic_status === "COMPLETED"
          ? "profileSummary"
          : ""
      } ${!llShowOnly ? "tenant_Profile_summary" : ""}`}
      style={{
        ...(userType === "admin"
          ? {
              marginTop: "8.8056vw",
            }
          : {}),
      }}
    >
      <DetailsSkor
        user={user}
        combinedIncome={combinedIncome}
        combinedIncomeForTable={combinedIncomeForTable}
        effortObj={effortObj}
        handleSaveEffortRateData={handleSaveEffortRateData}
        loadFullInfo={loadFullInfo}
        userIncome={userIncome}
        gurantorsIncome={gurantorsIncome}
        handleIncomeChange={handleIncomeChange}
        totalIncomeModal={totalIncomeModal}
        setTotalIncomeModal={setTotalIncomeModal}
        showReportIcons={showReportIcons}
        handleFinancialIncomeChange={handleFinancialIncomeChange}
        selectedFinancialIncomeSourceData={selectedFinancialIncomeSourceData}
        selectedSources={selectedSources}
        setSelectedSources={setSelectedSources}
        isGuarantor={isGuarantor}
        paymentScoreLoading={paymentScoreLoading}
        setPaymentScoreLoading={setPaymentScoreLoading}
        Bankshow={Bankshow}
        setBankshow={setBankshow}
        reconnectFlow={reconnectFlow}
        setReconnectFlow={setReconnectFlow}
        updateTenantData={updateTenantData}
        scoreValue={scoreValue}
        setScoreValue={setScoreValue}
        getAnalysisDetails={getAnalysisDetails}
        financial_info_errors={financial_info_errors}
        setFinancial_info_errors={setFinancial_info_errors}
        profileId={
          fullinfo?.tenant_id?.profileId ?? agencylink ?? sharedprofileid
        }
        excluded_income_source_ids={fullinfo?.excluded_income_source_ids ?? []}
        effortRateType={effortRateType}
        setEffortRateType={setEffortRateType}
        totalGuarantorIncome={totalGuarantorIncome}
        totalGurantorIncomeForTable={totalGurantorIncomeForTable}
        showEffortRateCalcuator={showEffortRateCalcuator}
        setShowEffortRateCalcuator={setShowEffortRateCalcuator}
        fullinfo={fullinfo}
        fullInfoForGurantor={fullInfoForGurantor}
        guarantor_id={guarantor_id}
        llShowOnly={llShowOnly}
        hideEffortRate={hideEffortRate}
      />
    </div>
  );

  return (
    <>
      <div
        className={`skor-profile-layout ${
          llShowOnly
            ? "main-page-wrapper"
            : "main-page-wrapper main-page-wrapper-tenant"
        } ${
          llShowOnly
            ? "skor-profile-layout--landlord"
            : "skor-profile-layout--tenant"
        } mb-4 position-relative`}
      >
        <div className="skor-profile-layout__notices">
          {llShowOnly && fullinfo?.tenantid?.is_outdated && (
            <div
              className={`outdated-profile-banner ${
                profileUpdateRequestedAt
                  ? "profile-update-requested-banner"
                  : ""
              }`}
              role="status"
            >
              <div className="outdated-profile-banner-icon">
                <img
                  src={
                    profileUpdateRequestedAt
                      ? "/images/clock-icon.svg"
                      : "/images/warning-dark-yellow.svg"
                  }
                  alt=""
                />
              </div>
              <div className="outdated-profile-banner-content">
                <h4>
                  {profileUpdateRequestedAt
                    ? _t("profileUpdateRequested", "Update requested")
                    : _t("thisProfileIsOutdated", "This profile is outdated")}
                </h4>
                <p>
                  {profileUpdateRequestedAt ? (
                    <>
                      <strong>
                        {_t(
                          "profileUpdateRequestedDescriptionTitle",
                          "Waiting for the tenant to update their profile."
                        )}
                      </strong>{" "}
                      {_t(
                        "profileUpdateRequestedDescription",
                        "You can keep viewing the last data they shared and decide once the profile is refreshed."
                      )}
                    </>
                  ) : (
                    _t(
                      "outdatedProfileDescription",
                      "You can continue viewing the data from the last time the tenant updated it. If you want to evaluate them again, we recommend requesting an update so you can decide based on their current situation."
                    )
                  )}
                </p>
                {profileUpdateRequestedAt ? (
                  <p className="profile-update-requested-meta">
                    {lastProfileReminderSentAt
                      ? _t(
                          "profileUpdateReminderSentJustNow",
                          "Last reminder sent just now"
                        )
                      : _t(
                          "profileUpdateRequestedOn",
                          "Requested {{date}}",
                          undefined,
                          { date: requestedOn }
                        )}
                    <span aria-hidden="true">&bull;</span>
                    {_t(
                      "tenantHasBeenNotified",
                      "The tenant has been notified"
                    )}
                  </p>
                ) : null}
              </div>
              <button
                className={
                  profileUpdateRequestedAt
                    ? "profile-update-resend-button"
                    : undefined
                }
                type="button"
                onClick={() => setShowProfileUpdateModal(true)}
              >
                {profileUpdateRequestedAt
                  ? _t("resendProfileUpdateRequest", "Resend request")
                  : _t("requestProfileUpdate", "Request update")}
              </button>
            </div>
          )}
        </div>
        <div className="skor-profile-layout__header">
          {llShowOnly ? (
            <TenantDetailsHeader
              user={user}
              fullinfo={fullinfo}
              forensicAnalysis={forensicAnalysis}
              userIncome={userIncome}
              setShowDefaulterCheck={setShowDefaulterCheck}
              totalIncomeModal={totalIncomeModal}
              setOpenGuarantorModel={setOpenGuarantorModel}
              setTotalIncomeModal={setTotalIncomeModal}
              setUpdateSourceObj={setUpdateSourceObj}
              updateSourceObj={updateSourceObj}
              showReportIcons={showReportIcons}
              handleUpdateSource={() => {
                setTotalIncomeModal(false);
                setUpdateIncomeSourceModal(true);
              }}
              isGuarantor={isGuarantor}
              setShowChatBot={setShowChatBot}
              SetIsSentEmailDrawer={SetIsSentEmailDrawer}
              updateTenantData={updateTenantData}
              loadFullInfo={loadFullInfo}
              setInsurableModal={setInsurableModal}
              llShowOnly={llShowOnly}
            />
          ) : (
            <>
              {!llShowOnly && !isGuarantor && user?.is_outdated && (
                <div
                  className="outdated-profile-banner tenant-outdated-profile-banner"
                  role="status"
                >
                  <div className="outdated-profile-banner-icon">
                    <img src="/images/warning-dark-yellow.svg" alt="" />
                  </div>
                  <div className="outdated-profile-banner-content">
                    <h4>
                      {_t("yourProfileIsOutdated", "Your profile is outdated")}
                    </h4>
                    <p>
                      {_t(
                        "tenantOutdatedProfileDescription",
                        "You can continue viewing your data normally. Profiles stay current for 3 months; update yours so landlords can assess your current situation. It only takes a few minutes and keeps your profile current for another 3 months."
                      )}
                    </p>
                  </div>
                  <button
                    type="button"
                    disabled={profileRenewalLoading}
                    onClick={handleStartRenewProfile}
                  >
                    {profileRenewalLoading
                      ? `${_t("updating")}...`
                      : _t("updateProfile", "Update profile")}
                  </button>
                </div>
              )}
              {!llShowOnly && <TenantGreeting user={user} />}
              <TenantHeaderCard
                percent={profileCompletionPercent}
                percentageLoading={completionLoading}
                missingDocs={employmentMissingDocs}
                requiredDocs={requiredDocsList}
                kycStatus={tenantKycLabel}
                kycState={tenantKycState}
                bankConnected={bankConnected}
                rentalStatus={rentalBarometerStatus}
                guarantorCount={user?.gurantor_added_id?.length ?? 0}
                flatmateCount={myApplications?.length ?? 0}
                onRedoKyc={() => setShowKycPopup(true)}
                onConnectBank={() => {
                  setBankshow(true);
                  setReconnectFlow(false);
                }}
                onAddGuarantor={() => {
                  const c = user?.gurantor_added_id?.length ?? 0;
                  if (c === 0) navigate("/guarantor/onboarding");
                  else setOpenGuarantorModel(true);
                }}
                onAddFlatmate={() => setShowApplicationsModal(true)}
              />
            </>
          )}
        </div>
        {llShowOnly && (
          <>
            {renderScoreSection()}
            <div className="skor-profile-layout__details mt-3">
              {profileDetailsReady ? (
                <div className="row align-items-stretch skor-profile-details-grid">
                  {renderDocumentsSection()}
                  {renderInformationSection(
                    "col-md-6 custom-items--stretch skor-profile-details-grid__information"
                  )}
                </div>
              ) : (
                renderDetailsLoadingState()
              )}
            </div>
          </>
        )}
        {!llShowOnly && (
          <>
            {profileDetailsReady ? (
              <div className="tenant-profile-content-columns">
                <div className="tenant-profile-content-column tenant-profile-content-column--left">
                  <WaysToStrengthenProfile
                    missingDocsCount={employmentMissingCount}
                    isBankConnected={Boolean(
                      user?.bank_status && !financial_info_errors
                    )}
                    hasSkorProtect={Boolean(
                      user?.skor_protect ||
                      fullinfo?.skor_protect ||
                      fullinfo?.tenantid?.skor_protect
                    )}
                    onUpdateDocs={() => setUploadDocModel(true)}
                    onLinkBank={() => {
                      setBankshow(true);
                      setReconnectFlow(false);
                    }}
                    onBuyProtect={() => {}}
                    onSkorProtectEnabled={() => loadFullInfo(false)}
                  />
                  <div className="tenant-profile-documents-slot">
                    {renderDocumentsSection()}
                  </div>
                  {renderScoreSection({ hideEffortRate: true })}
                </div>
                <div className="tenant-profile-content-column tenant-profile-content-column--right">
                  <TargetRent
                    monthlyIncome={monthlyIncomeVal}
                    rent={tenantRent ?? 0}
                    onRentChange={handleTenantRentChange}
                    hasGuarantor={(user?.gurantor_added_id?.length ?? 0) > 0}
                    hasFlatmate={(myApplications?.length ?? 0) > 0}
                    onAddGuarantor={() => {
                      const count =
                        (user?.gurantor_added_id?.length ?? 0) +
                        (user?.tenant_extra_field_id?.selected_onboarding_users?.filter(
                          (u) => u?.type === "guarantor"
                        )?.length ?? 0);
                      if (count === 0) navigate("/guarantor/onboarding");
                      else setOpenGuarantorModel(true);
                    }}
                    onAddFlatmate={() => setShowApplicationsModal(true)}
                  />
                  {renderInformationSection(
                    "tenant-profile-information-slot custom-items--stretch"
                  )}
                  <NoteForLandlord
                    note={user?.about_me}
                    onEditNote={() => setShowFreeTextPopup(true)}
                  />
                </div>
              </div>
            ) : (
              <div className="tenant-profile-details-state-layout">
                <div className="tenant-profile-details-state">
                  {renderDetailsLoadingState()}
                </div>
                {renderScoreSection({ hideEffortRate: true })}
                <NoteForLandlord
                  note={user?.about_me}
                  onEditNote={() => setShowFreeTextPopup(true)}
                />
              </div>
            )}
          </>
        )}
        {showReportIcons && llShowOnly && (
          <div className="skor-profile-layout__assistant SkorAI_logo">
            <img
              onClick={() => setShowChatBot(true)}
              className="animated-image cursor-pointer"
              src={SkorAi}
              alt="Vector Icon"
            />
          </div>
        )}
      </div>

      {/* Page-owned overlays */}
      <div
        className={`wrapper-modal d-flex align-items-center justify-content-end ${
          showChatBot ? "chatbot-visible" : "chatbot-hidden"
        }`}
        onClick={() => setShowChatBot(false)}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="skorlite-chatbot-div"
        >
          <div className="skorlite-chatbot-header">
            <div>
              <img className="animated-image" src={SkorAi} alt="Vector Icon" />
              <p>{_t("askSkor", "Chatbot Iframe thing")}</p>
            </div>
            <img
              src="/images/cancel-green.svg"
              className="cursor-pointer"
              alt=""
              onClick={() => setShowChatBot(false)}
            />
          </div>
          {showChatBot && (
            <iframe
              src={`${process.env.REACT_APP_SKOR_LITE_URL}${currentLang}/chat/${user?._id}`}
              frameBorder="0"
              className="chatbot-iframe"
              title={_t("askSkor", "Ask Skor")}
            />
          )}
        </div>
      </div>
      <Summary
        user={user}
        showReportIcons={showReportIcons}
        setShowChatBot={setShowChatBot}
        llShowOnly={llShowOnly}
      />
      <ProfileUpdateRequestModal
        isOpen={showProfileUpdateModal}
        tenant={user}
        requestedAt={profileUpdateRequestedAt}
        currentLang={currentLang}
        isSending={profileUpdateReminderLoading}
        onClose={() => setShowProfileUpdateModal(false)}
        onSend={handleSendProfileUpdateReminder}
      />
      <DataInfoModal
        isOpen={openInfoModal}
        onClose={() => setOpenInfoModal(false)}
        infoModal={infoModal}
        handleUpdateSource={() => {
          setOpenInfoModal(false);
          setUpdateIncomeSourceModal(true);
        }}
        claveDocs={claveDocs}
        verifiedDocs={verifiedDocs}
        docsMap={docsMap}
        forensicAnalysis={forensicAnalysis}
        uploadedTenantDocs={uploadedTenantDocs}
      />
      {showDefaulterCheck && (
        <DefaultCheckReportModal
          isOpen={showDefaulterCheck}
          onClose={() => setShowDefaulterCheck(false)}
          user={user}
        />
      )}
      {updateIncomeSourceModal && (
        <UpdatedIncomeSourceModal
          show={updateIncomeSourceModal}
          onHide={() => {
            setUpdateIncomeSourceModal(false);
            // setTotalIncomeModal(true);
          }}
          updateSourceList={updateSourceObj}
          handleIncomeChange={handleIncomeChange}
          loadFullInfo={loadFullInfo}
          savedCustomSources={fullinfo?.custom_income_sources}
          handleDeleteCustomIncome={handleDeleteCustomIncome}
        />
      )}

      <GuarantorDetails
        isOpen={openGuarantorModel}
        onClose={() => {
          setOpenGuarantorModel(false);
        }}
        user={user}
        effortObj={effortObj}
        userIncome={userIncome}
        gurantorsIncome={gurantorsIncome}
        setUpdateSourceObj={setUpdateSourceObj}
        showReportIcons={showReportIcons}
        llShowOnly={llShowOnly}
        isGuarantor={(user?.gurantor_for?.length ?? 0) > 0 ?? isGuarantor}
      />

      {pendingGuaranteesRequests.length > 0 ? (
        <>
          <PendingRequestsPopup
            handleAcceptModal={() => setIsAcceptModalOpen(true)}
            show={pendingGuaranteesRequests.length > 0}
            pendingGuarantees={pendingGuaranteesRequests}
            loadPendingGuarantees={loadPendingGuarantees}
            loading={pendingRequestsGuranteesLoading}
            setLoading={setPendingRequestsGuranteesLoading}
            setPendingGuaranteesRequests={setPendingGuaranteesRequests}
            setAcceptedGuaranteeName={setAcceptedGuaranteeName}
          />
        </>
      ) : null}

      {isSentEmailDrawer && (
        <SendTenantEmailDrawer
          user={user}
          globalAllForensicDocuments={globalAllForensicDocuments}
          isOpen={isSentEmailDrawer}
          onClose={() => SetIsSentEmailDrawer(false)}
          globalTenantDocuments={globalTenantDocuments}
          currentLang={currentLang}
          globalTenantDocsHistory={globalTenantDocsHistory}
          globalMandatoryDocsList={globalMandatoryDocsList}
        />
      )}
      <LinkedTenantsProperties
        propertiesData={propertiesData}
        showPropertiesPopup={showPropertiesPopup}
        setShowPropertiesPopup={setShowPropertiesPopup}
      />
      {insurableModal && (
        <TenantProfileInsuranceModal
          user={user}
          propertiesData={propertiesData}
          setShowPropertiesPopup={setShowPropertiesPopup}
          propertyDataLoading={propertyDataLoading}
          isOpen={insurableModal}
          onClose={() => setInsurableModal(false)}
        />
      )}
      {standaloneJoinApps.length > 0 && (
        <div className="wrapper-modal isf-overlay">
          <div className="isf-container" onClick={(e) => e.stopPropagation()}>
            <JoinGroupScreen
              app={standaloneJoinApps[0]}
              landlordData={null}
              onBack={null}
              onClose={null}
              onAccept={handleStandaloneAccept}
              onDecline={handleStandaloneDecline}
              processing={standaloneJoinProcessing}
              user={user}
              _t={_t}
            />
          </div>
        </div>
      )}

      <InvitationShareModal
        isOpen={showInvitationShareModal}
        landlordId={cookies.requestProfileLink}
        propertyId={cookies.property_id}
        onClearCookies={() => {
          removeCookie("requestProfileLink", { path: "/", maxAge: 1800 });
          if (haveValue(cookies.property_id)) {
            removeCookie("property_id", { path: "/", maxAge: 1800 });
          }
          if (haveValue(cookies.invitationToken)) {
            removeCookie("invitationToken", { path: "/", maxAge: 1800 });
          }
        }}
        onClose={() => {
          setShowInvitationShareModal(false);
        }}
        onNeedsConsent={(landlordDataFromModal, postConsentAction) => {
          postConsentActionRef.current = postConsentAction;
          setShowInvitationShareModal(false);
          setConsentLandlordData(landlordDataFromModal);
          setShowConsent(true);
        }}
        onDone={() => {
          setShowInvitationShareModal(false);
        }}
      />
      {showConsent && (
        <ConsentStepModal
          user={user}
          isPopup={true}
          onClose={() => {
            removeCookie("requestProfileLink", { path: "/", maxAge: 1800 });
            if (haveValue(cookies.property_id)) {
              removeCookie("property_id", { path: "/", maxAge: 1800 });
            }

            setShowConsent(false);
          }}
          loadUserTenant={loadUserTenant}
          selectedLandlord={consentLandlordData}
          shareProfileWithLandlord={async () => {
            if (postConsentActionRef.current) {
              await postConsentActionRef.current();
              postConsentActionRef.current = null;
            } else {
              const havePropertyId = haveValue(cookies.property_id);
              const payload = { shareType: "lLink" };
              if (havePropertyId) payload.property_id = cookies.property_id;
              await shareProfile(
                originalUser._id,
                cookies.requestProfileLink,
                "null",
                "full",
                payload
              );
            }
          }}
        />
      )}
      <RequestAcceptingModal
        show={isAcceptModalOpen}
        onClose={() => setIsAcceptModalOpen(false)}
        acceptedGuaranteeName={acceptedGuaranteeName}
      />
      {!isGuarantor && (
        <ApplicationsModal
          isOpen={showApplicationsModal}
          onClose={() => setShowApplicationsModal(false)}
          applications={[
            ...(pendingApplications?.map((a) => ({
              ...a,
              isPendingInvitation: true,
            })) ?? []),
            ...(myApplications ?? []),
          ]}
          loading={false}
          onNewApplication={() => setShowNewApplicationModal(true)}
          onApplicationsChange={loadApplicationsData}
          llShowOnly={false}
        />
      )}
      <NewApplicationModal
        isOpen={showNewApplicationModal}
        onClose={() => {
          setShowNewApplicationModal(false);
          setShowApplicationsModal(true);
        }}
        onSuccess={loadApplicationsData}
      />
      {showFreeTextPopup && (
        <FreeTextModal
          user={user}
          showFreeTextPopup={showFreeTextPopup}
          setShowFreeTextPopup={setShowFreeTextPopup}
          updateTenantData={updateTenantData}
          loadFullInfo={loadFullInfo}
          isPopup={true}
        />
      )}
      {showKycPopup && (
        <FullidAuthentication
          user={user}
          isGuarantor={isGuarantor}
          usedFor="popup"
          setShowKycPopup={setShowKycPopup}
        />
      )}
      {/* !isGuarantor means tenant viewing guarantor's profile */}
      {showDuplicateModal && !isGuarantor && (
        <DuplicateDocModal
          showDuplicateModal={showDuplicateModal}
          setShowDuplicateModal={setShowDuplicateModal}
          duplicateDocsByProfile={duplicateDocsByProfile}
          setDuplicateDocsByProfile={setDuplicateDocsByProfile}
        />
      )}
    </>
  );
}

export default SkorList;
